<card-layout title="Summary" icon="perm_media_outline">
    <p class="review">Please review the information you have provided</p>
    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header [class.screen-invalid]="_screenValidation?.yourDetails == false">
                <mat-icon>person</mat-icon><span class="header">Your Details</span>
            </mat-expansion-panel-header>
            <summary-card [screen]="_screen.Personal" [isValid]="_screenValidation!.personal">
                <ul class="bottom">
                    <li><h4>Personal Details</h4></li>
                    <li><span>Full Name:</span> <b>{{ selectTitle('client') }} {{ _claim.claimant.forename || '' }}{{ _claim.claimant.middleName ? ' ' + _claim.claimant.middleName : '' }}{{ _claim.claimant.surname ? ' ' + _claim.claimant.surname : '' }}</b></li>
                    <li><span>DOB:</span> <b>{{ _claim.claimant.dateOfBirth | dateFormat }}</b></li>
                    <li><span>Email:</span> <b>{{ _customer.emailAddress   }}</b></li>
                    <li><span>Primary Contact:</span> <b>{{ _customer.customerContactDetails[0].telephoneNumber }}</b></li>
                    @if(_customer.customerContactDetails.length > 1){
                        <li><span>Secondary Contact:</span> <b>{{ _customer.customerContactDetails[1].telephoneNumber }}</b></li>
                    } 
                    <li><span>Address 1:</span> <b>{{ _customer.address.address1 }}</b></li>
                    <li><span>Address 2:</span> <b>{{ _customer.address.address2 }}</b></li>
                    <li><span>Address 3:</span> <b>{{ _customer.address.address3 }}</b></li>
                    <li><span>Town/City:</span> <b>{{ _customer.address.city }}</b></li>
                    <li><span>County:</span> <b>{{ _customer.address.county }}</b></li>
                    <li><span>Postcode:</span> <b>{{ _customer.address.postcode }}</b></li>
                    <li><span>Country:</span> <b>{{ _customer.address.country }}</b></li>
                </ul>
            </summary-card>
            <hr />
            <summary-card [screen]="_screen.Employment" [isValid]="_screenValidation!.employment">
                <ul class="bottom">
                    <li><h4>Employment Details</h4></li>
                    <li><span>Employment Status: </span><b>{{ employmentStatus }}</b></li>
                    @if (isOccupationVisible) {
                        <li><span>Occupation: </span><b>{{ _claim.claimant.occupation }}</b></li>
                        <li><span>Time off Work: </span><b>{{ _claim.injury.hasTakenTimeOffWork === null ? '' : (_claim.injury.hasTakenTimeOffWork ? 'Yes' : 'No') }}</b></li>

                        @if (_claim.injury.hasTakenTimeOffWork) {
                        <li><span>Time off Work - Still Ongoing: </span><b>{{ _claim.injury.isStillOffWork === null ? '' : _claim.injury.isStillOffWork ? 'Yes' : 'No' }}</b></li>
                        <li><span>Days off Work: </span><b>{{_claim.injury.daysOffWork}}</b></li>
                        }
                    }
                    <li><span>NI Number: </span><b>{{ niNumber }}</b></li>
                </ul>
            </summary-card>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header [class.screen-invalid]="_screenValidation?.yourAccident == false">
                <mat-icon>car_crash</mat-icon><span class="header">Your Accident</span>
            </mat-expansion-panel-header>
            <summary-card [screen]="_screen.YourAccidentYourInvolvement" [isValid]="_screenValidation!.yourAccidentYourInvolvement">
                <ul class="bottom">
                    <li><h4>Involvement Details</h4></li>
                    <li><span>Type of Vehicle:</span><b>{{ productType }}</b></li>
                    <li><span>How were you involved:</span> <b>{{ claimantType }}</b></li>
                    @if(isBusCarVanLorryPassenger) {
                        <li><span>Evidence of Travel:</span> <b>{{ _claim.accident.hasEvidenceOfTravel === null ? '' : (_claim.accident.hasEvidenceOfTravel ? 'Yes' : 'No') }}</b></li>
                    }
                    <li><span>Number of Drivers:</span> <b>{{ (_claim.numberOfOccupants - _claim.numberOfPassengers) }}</b></li>
                    <li><span>Number of Passengers:</span> <b>{{ _claim.numberOfPassengers }}</b></li>
                    @if (isDriver) {
                        <li><span>Vehicle Owner:</span> <b>{{ _claim.isVehicleOwner === null ? '' : (_claim.isVehicleOwner ? 'Yes' : 'No') }}</b></li>
                    }
                    @if (isPassenger) {
                        <li><h4>Driver Details</h4></li>
                        <li><span>Driver at Fault:</span><b>{{ _claim.claimVehicle.isDriverAtFault === null ? '' : (_claim.claimVehicle.isDriverAtFault ? 'Yes' : 'No') }}</b></li>
                        <li><span>Full Name:</span> <b>{{ _driver.forename || '' }}{{ _driver.surname ? ' ' + _driver.surname : '' }}</b></li>
                        <li><span>Email:</span> <b> {{ _driver.emailAddress }}</b></li>
                        <li><span>Primary Contact Number:</span><b>{{ _driver.occupantContactDetails[0].telephoneNumber }}</b></li>
                        @if ( _driver.occupantContactDetails.length > 1) {
                            <li><span>Secondary Contact Number:</span><b>{{ _driver.occupantContactDetails[1].telephoneNumber }}</b></li>
                        }
                    }
                    <li><span>Seatbelt Worn:</span> <b>{{ isSeatBeltWorn }}</b></li>
                </ul>
            </summary-card>
            <hr />
            <summary-card [screen]="_screen.YourAccidentTimeLocation" [isValid]="_screenValidation!.yourAccidentYourTimeLocation">
                <ul class="bottom">
                    <li><h4>Time & Location Details</h4></li>
                    <li>Accident Date: <b>{{ _claim.accident.accidentDate | dateFormat }}</b></li>
                    <li>Accident Time: <b>{{ _claim.accident.accidentTime | timeFormat }}</b></li>
                    <li>Accident Country: <b>{{ accidentCountry }}</b></li>
                    <li>Accident Road: <b>{{ _claim.accident.accidentRoad }}</b></li>
                    <li>Accident Town: <b>{{ _claim.accident.accidentTown }}</b></li>
                </ul>
            </summary-card>
            <hr />
            <summary-card [screen]="_screen.YourAccidentDescription" [isValid]="_screenValidation!.yourAccidentDescription">
                <ul class="bottom">
                    <li><h4>Description Details</h4></li>
                    <li>Accident Description: <b>{{ _claim.accident.accidentDescription }}</b></li>
                    <li>Accident Summary: <b>{{ accidentSummary }}</b></li>
                    <li>Your Estimated Speed: <b>{{ vehicleSpeed }}</b></li>
                    <li>CCTV or Dashcam Footage: <b>{{ _claim.accident.hasAccidentCctv === null ? '' : (_claim.accident.hasAccidentCctv ? 'Yes' : 'No') }}</b></li>
                    <li>Photo evidence of damage to vehicle: <b>{{ _claim.accident.hasAccidentPhoto === null ? '' : (_claim.accident.hasAccidentPhoto ? 'Yes' : 'No') }}</b></li>
                </ul>
            </summary-card>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header [class.screen-invalid]="_screenValidation?.yourInjuries == false">
                <mat-icon>personal_injury</mat-icon><span class="header">Your Injuries</span>
            </mat-expansion-panel-header>
            <summary-card [screen]="_screen.YourInjuriesDetails" [isValid]="_screenValidation!.yourInjuriesDetails">
                <ul class="bottom">
                    @for (i of _claim.injury.injuryDetails; track i.injuryDetailId; let index = $index) {
                        <li><h4>Injury {{ index + 1 }}</h4></li>
                        <li><span>Area of Body:</span> <b>{{ selectedAreaOfBody(index) }}</b></li>
                        <li><span>Body Part:</span> <b>{{ selectedBodyPart(index) }}</b></li>
                        <li><span>Injury Type:</span> <b>{{ selectedInjuryType(index) }}</b></li>
                        <li><span>Pre-Existing Injury:</span> <b>{{ i.preExistingInjury }}</b></li>
                    }
                    <li><h4>Injury Details</h4></li>
                    <li><span>Pre-Existing Conditions:</span> <b>{{ _claim.injury.isInjuriesPreExisting === null ? '' : (_claim.injury.isInjuriesPreExisting ? 'Yes' : 'No') }}</b></li>
                    @if (_claim.injury.isInjuriesPreExisting) {
                        <li><span>Pre-Existing Condition Description:</span><b>{{ _claim.injury.preExistingInjuriesDetail }}</b></li>
                    }   
                    <li><span>Is your whiplash exceptionally severe:</span> <b>{{ _claim.injury.isWhiplashSevere === null ? '' : (_claim.injury.isWhiplashSevere ? 'Yes' : 'No') }}</b></li>
                    @if (_claim.injury.isWhiplashSevere) {
                        <li><span>If so why:</span><b>{{ _claim.injury.severeWhiplashDescription }}</b></li>
                    }
                    <li><span>Are your Circumstances Exceptional:</span><b>{{ _claim.injury.isCircumstanceExceptional === null ? '' : (_claim.injury.isCircumstanceExceptional ? 'Yes' : 'No') }}</b></li>
                    @if (_claim.injury.isCircumstanceExceptional) {
                        <li><span>If yes why:</span><b>{{ _claim.injury.circumstanceExceptionalDescription }}</b></li>
                    }
                </ul>
            </summary-card>
            <hr />
            <summary-card [screen]="_screen.YourInjuriesMedicalAttention" [isValid]="_screenValidation!.yourInjuriesMedicalAttention">
                <ul class="bottom">
                    <li><h4>Medical Details</h4></li>
                    <li>Have you had medical attention: <b> {{ _claim.injury.isMedicalAttentionSought === null ? '' : (_claim.injury.isMedicalAttentionSought ? 'Yes' : 'No') }}</b></li>
                    @if (_claim.injury.isMedicalAttentionSought) {
                        <li>Seen GP: <b>{{ _claim.injury.isGpSought === null ? '' : (_claim.injury.isGpSought ? 'Yes' : 'No') }}</b></li>
                        <li>Seen Paramedic: <b>{{ _claim.injury.isParamedicSought === null ? '' : (_claim.injury.isParamedicSought ? 'Yes' : 'No') }}</b></li>
                        <li>Treated at a Hospital: <b>{{ _claim.injury.isHospitalSought === null ? '' : (_claim.injury.isHospitalSought ? 'Yes' : 'No') }}</b></li>
                        @if (_claim.injury.isHospitalSought) {
                            <li>Hospital Name: <b>{{ hospitalName }}</b></li>
                            <li>Nights Spent at Hospital: <b>{{ hospitalNights }}</b></li>
                        }
                        <li>Further Doctor Treatment Recommended: <b>{{ injuryAnyOtherTreatment }}</b></li>
                    }
                </ul>
            </summary-card>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header [class.screen-invalid]="_screenValidation?.yourVehicle == false">
                <mat-icon>directions_car</mat-icon><span class="header">Your Vehicle</span>
            </mat-expansion-panel-header>
            <summary-card [screen]="_screen.YourVehicle" [isValid]="_screenValidation!.yourVehicle">
                <ul class="bottom">
                    <li><h4>Vehicle Details</h4></li>
                    <li><span>Vehicle Registration:</span> <b>{{ _claim.claimVehicle.vehicleRegistrationNumber }}</b></li>
                    <li><span>Make:</span><b>{{ _claim.claimVehicle.vehicleMake }}</b></li>
                    <li><span>Model:</span> <b>{{ _claim.claimVehicle.vehicleModel }}</b></li>
                    <li><span>Colour:</span><b>{{ _claim.claimVehicle.vehicleColour }}</b></li>
                    <!-- <li><span>Evidence of the Damage:</span> <b>{{_claim.claimVehicle.isClaimingDamage === null ? '' : (_claim.claimVehicle.isClaimingDamage ? 'Yes' : 'No') }}</b></li> -->
                    @if(isVehicleOwner){
                        <li><span>Need Help Repairing your Vehicle:</span><b>{{_vehicleRepair.isRepairHelpRequired === null ? '' : (_vehicleRepair.isRepairHelpRequired ? 'Yes' : 'No') }}</b></li>
                        @if (_vehicleRepair.isRepairHelpRequired === false) {
                            <li><span>If no, explain why:</span> <b>{{ repairHelpRequiredReason }}</b></li>
                        }
                        <li><span>Do you need a Temporary Vehicle:</span><b>{{_vehicleHire.isTemporaryReplacementVehicleNeeded === null ? '' : (_vehicleHire.isTemporaryReplacementVehicleNeeded ? 'Yes' : 'No') }}</b></li>
                        @if (_vehicleHire.isTemporaryReplacementVehicleNeeded === false) {
                            <li><span>If no, explain why:</span> <b>{{ whyHireNotNeeded }}</b></li>
                        }
                        @if (showCompanyName) {
                            <!-- <li><span>Name of the Company:</span> <b>{{ _vehicleHire.hireProvider }}</b></li> -->
                        }
                    }
                </ul>
            </summary-card>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header [class.screen-invalid]="_screenValidation?.involvedParties == false">
                <mat-icon>people</mat-icon><span class="header">Involved Parties</span>
            </mat-expansion-panel-header>
            <summary-card [screen]="_screen.ResponsibleParty" [isValid]="_screenValidation!.responsibleParty">
                <ul class="bottom">
                    <li><h4>Primary Third Party Details</h4></li>
                    <li><span>Details Available:</span><b>{{_thirdParty.personalDetailsNotKnown === null ? '' : (!_thirdParty.personalDetailsNotKnown ? 'Yes' : 'No') }}</b></li>
                    @if (!_thirdParty.personalDetailsNotKnown) {<li><span>How did you et the Details:</span> <b>{{ obtainedThirdPartyDetails }}</b></li>
                    }
                    @else{
                        <li><span>Can you get them:</span><b>{{_thirdParty.canYouGetTpDetails === null ? '' : (_thirdParty.canYouGetTpDetails ? 'Yes' : 'No') }}</b></li>
                    }
                    <li><span>Vehicle Registration:</span><b>{{ _thirdParty.vehicleRegistrationNumber }}</b></li>
                    <li><span>Make:</span><b>{{ _thirdParty.vehicleMake }}</b></li>
                    <li><span>Model:</span><b>{{ _thirdParty.vehicleModel }}</b></li>
                    <li><span>Colour:</span><b>{{ _thirdParty.vehicleColour }}</b></li>
                    <li><h4>Driver Details</h4></li>
                    <li><span>Full Name:</span> <b>{{ _thirdParty.thirdPartyDriverForename || '' }}{{ _thirdParty.thirdPartyDriverMiddleName ? ' ' + _thirdParty.thirdPartyDriverMiddleName : '' }}{{ _thirdParty.thirdPartyDriverSurname ? ' ' + _thirdParty.thirdPartyDriverSurname : '' }}</b></li>
                    <li><span>Primary Contact:</span> <b>{{ _thirdParty.thirdPartyContactDetails?.[0]?.telephoneNumber }}</b></li>
                    @if(_thirdParty.thirdPartyContactDetails!.length > 1){
                        <li><span>Secondary Contact:</span> <b>{{ _thirdParty.thirdPartyContactDetails?.[1]?.telephoneNumber }}</b></li>
                    } 
                    <li><span>Foreign Vehicle:</span><b>{{_thirdParty.isForeign === null ? '' : (_thirdParty.isForeign ? 'Yes' : 'No') }}</b></li>
                    <li><span>Commercial vehicle:</span> <b>{{_thirdParty.isCommercialVehicle === null ? '' : (_thirdParty.isCommercialVehicle ? 'Yes' : 'No') }}</b></li>
                    @if (_thirdParty.isCommercialVehicle) {
                        <li><h4>Vehicle Owner Details</h4></li>
                        <li><span>Owner name:</span><b>{{ _thirdParty.thirdPartyOwnerName }}</b></li>
                        <li><span>Address 1:</span> <b>{{ _thirdParty.thirdPartyOwnerAddress?.address1 }}</b></li>
                        <li><span>Address 2:</span> <b>{{ _thirdParty.thirdPartyOwnerAddress?.address2 }}</b></li>
                        <li><span>Address 3:</span> <b>{{ _thirdParty.thirdPartyOwnerAddress?.address3 }}</b></li>
                        <li><span>Town/City:</span> <b>{{ _thirdParty.thirdPartyOwnerAddress?.city }}</b></li>
                        <li><span>County:</span> <b>{{ _thirdParty.thirdPartyOwnerAddress?.address1 }}</b></li>
                        <li><span>Postcode:</span> <b>{{ _thirdParty.thirdPartyOwnerAddress?.postcode }}</b></li>
                        <li><span>Country:</span> <b>{{ _thirdParty.thirdPartyOwnerAddress?.country }}</b></li>
                    }
                    <li><span>Vehicle Insurance Details Known:</span><b>{{thirdPartyInsuranceKnown === null ? '' : (thirdPartyInsuranceKnown ? 'Yes' : 'No') }}</b></li>
                    @if (thirdPartyInsuranceKnown) {
                        <li><span>Insurer Name & Details:</span><b>{{ _thirdParty.insurerInfoAsProvidedByCustomer }}</b></li>
                    }
                    <li><span>Other Vehicles Involved:</span><b>{{additionalTpInvolved === null ? '' : (additionalTpInvolved ? 'Yes' : 'No') }}</b></li>
                    @if (additionalTpInvolved) {
                        @for (ov of additionalThirdParties; track ov; let index = $index) {
                            <li><h4>Other Vehicle {{ index + 1 }}</h4></li>
                            <li><span>Vehicle Reg & Driver:</span><b>{{ ov.vehicleRegistrationNumber }} - {{ ov.thirdPartyDriverForename }} {{ ov.thirdPartyDriverSurname }}</b></li>
                            <li><span>Primary Contact:</span> <b>{{ ov.thirdPartyContactDetails?.[0]?.telephoneNumber }}</b></li>
                            @if(ov.thirdPartyContactDetails!.length > 1){
                                <li><span>Secondary Contact:</span> <b>{{ ov.thirdPartyContactDetails?.[1]?.telephoneNumber }}</b></li>
                            } 
                        }
                    }
                </ul>
            </summary-card>
            <hr />
            <summary-card [screen]="_screen.Passengers" [isValid]="_screenValidation!.passengers">
                <ul class="bottom">
                    <li><h4>Passenger Details</h4></li>
                    <li><span>Number of Passengers:</span><b>{{ _claim.numberOfPassengers }}</b></li>
                    <li><span>Consent to Copy Accident and Vehicle Details:</span><b>{{_claim.canShareDataWithPassengers === null ? '' : (_claim.canShareDataWithPassengers ? 'Yes' : 'No') }}</b></li>
                    @for (p of passengers; track p; let index = $index) {
                        <li><h4>Passenger {{index + 1}}</h4></li>
                        <li><span>Full Name:</span> <b>{{ selectTitle('passenger', index) }} {{ p.forename || '' }}{{ p.surname ? ' ' + p.surname : '' }}</b></li>
                        <li><span>Primary Contact:</span> <b>{{ p.occupantContactDetails[0]?.telephoneNumber }}</b></li>
                        @if(p.occupantContactDetails!.length > 1){
                            <li><span>Secondary Contact:</span> <b>{{ p.occupantContactDetails[1]?.telephoneNumber }}</b></li>
                        } 
                        <li><span>Did They Suffer an Injury:</span><b>{{ getSufferedInjury(index) }}</b></li>
                    }
                </ul>
            </summary-card>
            <hr />
            <summary-card [screen]="_screen.PoliceAndWitnesses" [isValid]="_screenValidation!.policeAndWitnesses">
                <ul class="bottom">
                    <li><h4>Police Details</h4></li>
                    <li><span>Involvement:</span><b>{{ selectedPoliceInvolvement }}</b></li>
                    @if (policeInvolved) {
                        <li><span>Station Name:</span> <b>{{ _claim.police.stationName }}</b></li>
                        <li><span>Jurisdiction:</span> <b>{{ policeJuridiction }}</b></li>
                        <li><span>Reference Number:</span><b>{{ _claim.police.policeReferenceNumber }}</b></li>
                    }
                    <li><h4>Witness Details</h4></li>
                    <li><span>Were There Any Independent Witnesses:</span><b>{{_claim.witnesses.length > 0 === null ? '' : (_claim.witnesses.length > 0 ? 'Yes' : 'No') }}</b></li>
                    @if (_claim.witnesses.length > 0) {
                        @for (w of _claim.witnesses; track w; let index = $index) {
                            <li><h4>Witness {{ index + 1 }}</h4></li>
                            <li><span>Full Name:</span> <b>{{ selectTitle('witness', index) }} {{ w.forename || '' }}{{ w.surname ? ' ' + w.surname : '' }}</b></li>
                            <li><span>Email address:</span> <b>{{ w.emailAddress }}</b></li>
                            <li><span>Primary Contact:</span> <b>{{ w.contactDetails[0]?.telephoneNumber }}</b></li>
                            @if(w.contactDetails!.length > 1){
                                <li><span>Secondary Contact:</span> <b>{{ w.contactDetails[1]?.telephoneNumber }}</b></li>
                            } 
                        }
                    }
                </ul>
            </summary-card>
        </mat-expansion-panel>
    </mat-accordion>
</card-layout>
